import type { ConfigurationContextValue } from "./ConfigurationContext";

// The Echoflicks smile icon on a white tile — the same mark echoflicks.com
// uses. One asset serves both themes because the tile carries its own ground.
export const defaultDarkModeLogo = "./logos/logo_echoflicks_icon.svg";
export const defaultLightModeLogo = "./logos/logo_echoflicks_icon.svg";

export const defaultCurrency = "USD";

export const defaultTitle = "Echoflicks CRM";

export const defaultCompanySectors = [
  { value: "communication-services", label: "Communication Services" },
  { value: "consumer-discretionary", label: "Consumer Discretionary" },
  { value: "consumer-staples", label: "Consumer Staples" },
  { value: "energy", label: "Energy" },
  { value: "financials", label: "Financials" },
  { value: "health-care", label: "Health Care" },
  { value: "industrials", label: "Industrials" },
  { value: "information-technology", label: "Information Technology" },
  { value: "materials", label: "Materials" },
  { value: "real-estate", label: "Real Estate" },
  { value: "utilities", label: "Utilities" },
];

export const defaultDealStages = [
  { value: "opportunity", label: "Opportunity" },
  { value: "proposal-sent", label: "Proposal Sent" },
  { value: "in-negociation", label: "In Negotiation" },
  { value: "won", label: "Won" },
  { value: "lost", label: "Lost" },
  { value: "delayed", label: "Delayed" },
];

export const defaultDealPipelineStatuses = ["won"];

export const defaultDealCategories = [
  { value: "creator-campaign", label: "Creator campaign" },
  { value: "video-production", label: "Video production" },
  { value: "content-licensing", label: "Content licensing" },
  { value: "platform-integration", label: "Platform integration" },
  { value: "other", label: "Other" },
];

export const defaultNoteStatuses = [
  { value: "cold", label: "Cold", color: "#7dbde8" },
  { value: "warm", label: "Warm", color: "#e8cb7d" },
  { value: "hot", label: "Hot", color: "#e88b7d" },
  { value: "in-contract", label: "In Contract", color: "#a4e87d" },
];

export const defaultTaskTypes = [
  { value: "none", label: "None" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "creator-call", label: "Creator call" },
  { value: "demo", label: "Demo" },
  { value: "follow-up", label: "Follow-up" },
  { value: "contract", label: "Contract" },
  { value: "launch", label: "Launch" },
];

export const defaultConfiguration: ConfigurationContextValue = {
  companySectors: defaultCompanySectors,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
};
